/** Round euro estimates (AI settings round four, the founder's list of 2026-10-20; brief rule 5 and decision 3 after the red team's review):
 *  every euro forecast on a key rounds UP to the next step of a table, so the real bill surprises on the right side. Only estimates round;
 *  a limit the owner typed and past spending (Usage) keep their exact figures (items 9 and 10, decision 2). Pure. */

/** the steps, in euros; past the last one the next whole hundred */
export const EUR_STEPS = [0.05, 0.1, 0.25, 0.5, 0.75, 1, 1.5, 2, 3, 5, 7.5, 10, 15, 20, 30, 50, 75, 100] as const;
/** arithmetic noise: a figure a billionth above a step stays on it (item 14) */
const NOISE = 1e-9;

/** the smallest step at or above the figure (at least the first step); above the table the next whole hundred (item 13) */
export function roundUpEur(eur: number): number {
  const v = Math.max(0, eur);
  for (const s of EUR_STEPS) if (v <= s * (1 + NOISE)) return s;
  return Math.ceil(v / 100 - NOISE) * 100;
}
/** a figure in euros: whole euros without cents ("€2"), smaller amounts with two decimals ("€0.50") */
export const formatEur = (eur: number): string => (Number.isInteger(eur) ? `€${eur}` : `€${eur.toFixed(2)}`);
/** a range as an estimate, both ends rounded up: "about €0.10 to €0.25", or "about €0.25" when they round alike */
export function eurEstimate(lowEur: number, highEur: number): string {
  const low = roundUpEur(lowEur), high = roundUpEur(Math.max(lowEur, highEur));
  return high > low ? `about ${formatEur(low)} to ${formatEur(high)}` : `about ${formatEur(high)}`;
}
